import _ from 'lodash';
import * as Backbone from "backbone";
import CacheCollection from "collection/CacheCollection";

import template_AbsentVisibilityView from 'module/selpan/impl/person/view/AbsentVisibilityView.ejs';
import $ from "jquery";
import * as ScopedLocalStorage from "util/ScopedLocalStorage";
import {invokeLastFunc} from 'util/FuncUtil';
import {addSharedAppStateChangeCallback, compat_getSharedAppState, removeSharedAppStateChangeCallback} from 'module/SharedAppState/compat/compat_SharedAppState';

const cache = new CacheCollection();

/**
 * custom function for Person List Module: hide persons that are absent in the visible view date span
 */
export const AbsentVisibilityView = Backbone.View.extend({
	className: 'AbsentVisibilityView',
	storageName: 'AbsentVisibilityView',
	dqId: '+selpan.pers.AbsentVisibility',
	events: {
		"click .activateAbsentVisibilityStatus": 'activateAbsentVisibilityStatus',
		"click .deactivateAbsentVisibilityStatus": 'deactivateAbsentVisibilityStatus',
		"click .setHideMode": 'setHideMode',
		"click .setShowMode": 'setShowMode',
	},
	initialize: function (options) {
		this.delayed = invokeLastFunc(this, ['refreshPersonVisiblity'], 20);
		this.selpan = options.selpan;
		this.fav = options.fav;
		this.state = new Backbone.Model({
			active: false,
			mode: null,
		});
		this.loadSettings();

		this.listenTo(this.state, 'change', this.delayed.refreshPersonVisiblity);
		this.sharedAppStateId = addSharedAppStateChangeCallback(this.delayed.refreshPersonVisiblity, ['view_start', 'view_end'])
		this.listenTo(this.selpan.collection, "choiceModeChanged", this.delayed.refreshPersonVisiblity);
		this.listenTo(this.selpan.panelCollection, "update reset", this.delayed.refreshPersonVisiblity);

		this.delayed.refreshPersonVisiblity();
	},
	remove() {
		removeSharedAppStateChangeCallback(this.sharedAppStateId)
		return Backbone.View.prototype.remove.call(this)
	},
	isActive() {
		return !!(this.state.get('active') && this.state.get('mode'));
	},
	saveSettings: function () {
		ScopedLocalStorage.save(this.storageName, {
			state: this.state.toJSON(),
		});
	},
	/** only override current status value when it is valid.
	 * otherwise the default value from initialize() will always be overwritten */
	loadSettings: function () {
		let store = ScopedLocalStorage.load(this.storageName);
		this.state.set(store && store.state);
	},
	isApplicable() {
		let multiChoice = !this.selpan.collection.isSingleChoiceMode();
		if (!multiChoice) return false;
		let appState = _.pick(compat_getSharedAppState(), ['view_start', 'view_end']);
		let validAppState = _.keysIn(appState).length === 2 && _.every(appState, p => typeof p === 'number' && !isNaN(p));
		if (!validAppState) return false;

		return true;
	},
	activateAbsentVisibilityStatus() {
		this.state.set({
			active: this.isApplicable(),
		});
	},
	deactivateAbsentVisibilityStatus() {
		this.selpan.collection.each(p => p.set({_hidden_absent: false}));
		this.state.set({
			active: false,
			mode: null,
		});
	},
	setHideMode() {
		this.state.set({mode: 'hide'});
	},
	setShowMode() {
		this.state.set({mode: 'show'});
	},
	refreshPersonVisiblity() {
		this.render();
		this.saveSettings();
		if (!this.state.get('active')) return;

		let exstAppState = _.pick(compat_getSharedAppState(), ['view_start', 'view_end']);
		let postData = JSON.stringify({
			id: this.dqId,
			params: exstAppState,
		});
		let $_dq = cache.getCache(postData);
		if (!$_dq) {
			$_dq = $.ajax({
				url: '../json/aacf',
				method: "POST",
				contentType: 'application/json',
				data: postData,
			});
			cache.setCache(postData, $_dq);
		}
		return $_dq.done(resp => this.execAction(_.map(resp && resp.elements, "value")));
	},
	execAction(persNrs) {
		let active = this.state.get('active');
		let mode = this.state.get('mode');
		if (!active || !mode) return;
		let allModels = this.selpan.collection.models;
		let filteredModels = _.compact(_.map(persNrs, persNr => {
			return this.selpan.panelCollection.get(persNr);
		}));
		if (mode === 'show') {
			_.each(allModels, m => m.set({_hidden_absent: true}));
			_.each(filteredModels, m => m.set({_hidden_absent: false}));
		} else {
			_.each(allModels, m => m.set({_hidden_absent: false}));
			_.each(filteredModels, m => m.set({_hidden_absent: true}));
		}
		this.selpan.deselectAll();
		this.selpan.selectPanelModels();
	},
	render: function () {
		if (!this.isApplicable()) {
			this.$el.empty();
			return;
		}
		this.$el.html(template_AbsentVisibilityView({
			active: this.state.get('active'),
			mode: this.state.get('mode'),
		}));
	},
});